import { getFileUrl } from './url';
import moment from 'moment';

import { LastLogin as LoginMessages } from '../messages/modules/Login';

export const getUserDisplayName = user =>
  user.fullName ? user.fullName : user.username;

export const getUserThumbnailUrl = user =>
  user && user.userThumbnail && getFileUrl(user.teamName, user.userThumbnail);

export const getUserThumbnailAltText = user => {
  if (!user || !getUserDisplayName(user)) {
    return '';
  }

  return getUserDisplayName(user)
    .slice(0, 1)
    .toUpperCase();
};

export const formatUserDisplayName = (userish = {}) => {
  const {
    fullName: fullNameProp,
    username,
    email,
    fieldName,
    nickname
  } = userish;
  const fullName = (fullNameProp || '').trim();

  if (fullName) {
    return fullName;
  }
  if (nickname) {
    return nickname;
  }
  if (username) {
    return `@${username}`;
  }
  if (email) {
    return email;
  }
  if (fieldName) {
    return `{{${fieldName}}}`;
  } else {
    return typeof userish === 'string' ? userish : '';
  }
};

export const formattedLastLoginMessage = (lastLogin, formatMessage) => {
  if (!lastLogin) {
    return '';
  }
  const loginDate = moment(lastLogin.loginDate).format('MMM D');
  const loginTime = moment(lastLogin.loginDate).format('h:mmA');

  if (lastLogin.isCurrentIP) {
    return formatMessage(LoginMessages.message.currentIP, {
      loginDate,
      loginTime
    });
  } else {
    return formatMessage(LoginMessages.message.differentIP, {
      loginDate,
      loginTime,
      ipAddress: lastLogin.ipAddress
    });
  }
};



// WEBPACK FOOTER //
// ./js/util/users.js